(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    var url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        function() {
          var card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
    if (!url.searchParams.has('sort_by')) {
      function applyDefaultSort() {
        var sectionEl = document.getElementById('shopify-section-{{ section.id }}');
        var form = sectionEl && sectionEl.querySelector('facets-form-component');
        if (form && typeof form.updateFilters === 'function') {
          form.updateFilters();
        }
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyDefaultSort, { once: true });
      } else {
        setTimeout(applyDefaultSort, 0);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
